import { convertMsToDynamicTime, roundToDigitNumber } from '@/common/utils/commonUtils';
import { convertCountWithUnit, convertValueWithUnit } from '@/common/utils/convertUnits.utils';
import { floor } from 'lodash-es';
import { CLOUD_SERVICE_CATEGORY } from '@/cloud/utils/define';

const convertTimeToUnit = (value: number, unit: string): string => {
  const truncateToThreeDecimal = (num: number) => Math.floor(num * 1000) / 1000;

  const unitConversions: { [key: string]: number } = {
    s: 1,
    sec: 1,
    seconds: 1,
    m: 60,
    h: 3600,
    d: 86400,
  };

  const seconds = value * (unitConversions[unit] ?? NaN);
  if (Number.isNaN(seconds)) {
    console.log('지원하지 않는 단위');
    return '';
  }

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = truncateToThreeDecimal(seconds % 60);

  return [
    days ? `${days}d` : '',
    hours ? `${hours}h` : '',
    minutes ? `${minutes}m` : '',
    `${secs}s`,
  ]
    .filter(Boolean)
    .join(' ');
};

export const convertAwsUnit = (
  value: number | undefined | null,
  unit = 'count',
  kind?: string,
): string | number | null | undefined => {
  if (value === null || value === undefined) return value;

  if (['s', 'sec', 'seconds', 'm', 'h'].includes(unit)) {
    return convertTimeToUnit(value, unit);
  }

  if (unit === 'count' || unit === null) {
    const { value: convertedValue, unit: convertedUnit } = convertCountWithUnit(value);
    const floorValue = floor(convertedValue, 3);
    return `${floorValue}${convertedUnit}${kind ? ` ${kind}` : ''}`;
  }

  if (unit === 'ms') {
    return convertMsToDynamicTime(value, 3);
  }

  const { value: convertedValue, unit: convertedUnit } = convertValueWithUnit(
    { value, unit },
    { roundingMode: 'floor' },
  );
  return `${roundToDigitNumber(convertedValue)}${convertedUnit}`;
};

export const getCloudServiceType = (service: string): string | undefined => {
  return Object.entries(CLOUD_SERVICE_CATEGORY).find(([_, values]) =>
    values.some((item) => service.includes(item)),
  )?.[0];
};
